
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/horoshop",
      function () {
        return require("private-next-pages/horoshop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/horoshop"])
      });
    }
  